import { mapState } from 'vuex';
export default {
  data() {
    return {
      tabList: [{
        val: 'title',
        label: 'Party name'
      }, {
        val: 'code',
        label: 'Party ID'
      }, {
        val: 'mode',
        label: 'Party mode'
      }, {
        val: 'email',
        label: 'Host'
      }, {
        val: 'operation',
        label: 'Operation'
      }]
    };
  },
  computed: {
    ...mapState({
      loginInfo: state => state.loginInfo
    })
  },
  props: {
    info: {
      type: Object,
      default: function () {
        return {};
      }
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hidePopup() {
      this.info.visiable = false;
    },
    closeEncoder(info) {
      info.loading = true;
      let params = {};
      const url = info.mode == 17 ? '/partyline-backend/globalControl/stopPushStream' : '/partyline-backend/party/stopPushStreamByR';
      if (info.mode == 17) {
        params = {
          globalControlId: info.globalControlId
        };
      } else {
        params = {
          outputSource: info.outputSource,
          partyCode: info.code,
          realPartyCode: info.realPartyCode,
          receiverId: info.rid
        };
      }
      this.axios.post(url, params).then(res => {
        if (res.data.errorCode === '0x0') {
          info.hasStop = true;
          this.$message.success(this.$t('common.stopSuccess'));
        }
        info.loading = false;
      });
    },
    showContent(info, key) {
      return info[key];
    },
    showStopButton(item, index) {
      if (index === 4 && !item.hasStop && !item.loginUser) {
        return true;
      }
      // if (item.loginUser) {
      if (index === 4 && !item.hasStop && item.loginUser.id === this.loginInfo.id) {
        return true;
      } else {
        return false;
      }
      // }
    },

    addHadStopClass({
      row
    }) {
      return row.hasStop ? 'hadStop' : '';
    }
  }
};